import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {IStore} from "../../../store/reducers";
import {Typography, TextField, FormControl, Select, MenuItem, Button, InputLabel, Paper, CircularProgress} from "@material-ui/core";
import actionTypes from "../../../store/actionTypes";
import {
    cultivos,
    INewParcelaSection,
    INotificacion, IPointCoords,
    ISections,
    ISistemasProduccion,
    sistemasProduccion,
    texturas, woody_crops
} from "../../../types";
import Caract_IMG from "../../../icons/PNGs/caract_img.png";
import {NavigateBefore} from "@material-ui/icons";
import {userService} from "../../../services/UserService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {LatLngTuple} from "leaflet";

const config = require('../../../config.json');
const texts = require('../../../texts/crearparcela.json');


interface IProps {
    menu: boolean
    nombre: string
    propietario: string
    usuarios: string[]
    cultivo: string
    id_estacion: number
    ubicacion_estacion: string
    sistema: null|ISistemasProduccion
    marco: string
    diametro: number
    textura: string
    level: number
    fecha: string
    dias: string
    idioma: string
    setPropietario(propietario: string): void
    setNombre(nombre: string): void
    setCultivo(cultivo: string): void
    notify(notification: INotificacion): void
    setIdEstacion(id_estacion: number): void
    setUbicacionEstacion(ubicacion_estacion: string): void
    setCoordenadasEstacion(coordenadas_estacion: IPointCoords): void
    setSistema(sistema: null|ISistemasProduccion): void
    setMarco(marco: string): void
    setDiametro(diametro: number): void
    selectSection(section: ISections): void
    setTextura(textura: string): void
    setCrearParcelaSection(seccion: INewParcelaSection): void
    setFecha(fecha: string): void
    setDias(dias: string): void
    openEstacionesDialog(callback: boolean): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
}

interface IState {
    hover: string
    marcoAcctivo: boolean
    completo: boolean
    text: Record<string, string>
    estacion: string
    id_estacion: number
    recomendaciones: Record<string, number|string>[]
    loading: boolean
}

class Caracterizacion extends React.Component<IProps, IState> {
    state: IState = {
        hover: '',
        marcoAcctivo: false,
        completo: false,
        text: texts[this.props.idioma],
        estacion: "",
        id_estacion: 0,
        recomendaciones: [] as Record<string, string>[],
        loading: false
    }

    componentDidMount() {
        this.setState({
            estacion: this.props.ubicacion_estacion,
            id_estacion: this.props.id_estacion
        })
        if (this.props.level < 5) {
            this.props.setPropietario(userService.getUser() as string)
        }
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.state.id_estacion === 0 && nextState.id_estacion !== 0) {
            this.setState({recomendaciones: []})
        }

        if (this.state.id_estacion !== nextState.id_estacion) {
            this.props.setIdEstacion(nextState.id_estacion)
        }

        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }

        if (
            nextProps.nombre.length !== 0 &&
            nextProps.propietario.length !== 0 &&
            nextProps.sistema !== null &&
            (nextProps.marco.split('x')[0] !== '0' || !woody_crops.includes(nextProps.cultivo)) &&
            (nextProps.marco.split('x')[1] !== '0' || !woody_crops.includes(nextProps.cultivo)) &&
            (nextProps.diametro !== 0 || !woody_crops.includes(nextProps.cultivo)) &&
            nextProps.cultivo.length !== 0 &&
            nextProps.textura.length !== 0 &&
            nextProps.id_estacion !== 0 &&
            nextProps.dias !== '0,0,0,0,0,0,0' &&
            !nextState.loading
        ) {
            if (!this.state.completo) this.setState({completo: true})
        } else {
            if (this.state.completo) this.setState({completo: false})
        }
        return true
    }

    handleSetName = (n: string) => {
        const name = n.replace(/ /gi, '')
        this.props.setNombre(name)
    }

    capitalizeFirstLetter = (s: string): string => {
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    second_try = () => {
        const address = (this.state.estacion.split(", ").slice(0, this.state.estacion.split(", ").length - 1)).join(",")
        axios.get(
            config.url+`/address2location?address=${address}`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.props.setCoordenadasEstacion({
                    lat: res.data["lat"],
                    lon: res.data["lon"]
                })
                this.props.setCenter([res.data["lat"], res.data["lon"]])
                this.props.setZoom(16)
                this.setState({loading: false})
                this.props.setCrearParcelaSection('Ubicación')
            })
            .catch(() => {
                this.props.notify({message: this.state.text["77"], variant: 'warning'})
                this.setState({loading: false})
            })
    }

    handleClick = () => {
        if (this.state.estacion === this.props.ubicacion_estacion) {
            this.props.setCrearParcelaSection('Ubicación')
        } else {
            this.props.setUbicacionEstacion(this.state.estacion)

            this.setState({loading: true})
            const address = (this.state.estacion.split(", ").slice(0, this.state.estacion.split(", ").length - 1)).join(",")
            axios.get(
                config.url+`/address2location?address=${address}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.props.setCoordenadasEstacion({
                        lat: res.data["lat"],
                        lon: res.data["lon"]
                    })
                    this.props.setCenter([res.data["lat"], res.data["lon"]])
                    this.props.setZoom(16)
                    this.setState({loading: false})
                    this.props.setCrearParcelaSection('Ubicación')
                })
                .catch(() => {
                    setTimeout(() => this.second_try(), 1000)
                })
        }
    }

    getRecomendaciones = (text: string) => {
        if (text.length >= 3) {
            axios.get(
                config.url+`/recomendacion/meteored?text=${text}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.setState({recomendaciones: res.data})
                })
                .catch(() => {})
        } else {
            this.setState({recomendaciones: []})
        }
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                    overflowX: "auto"
                }}
                onClick={() => {
                    if (this.state.hover === 'marco') {
                        this.setState({marcoAcctivo: true})
                    } else {
                        this.setState({marcoAcctivo: false})

                    }
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflowY: "auto",
                        overflowX: "hidden",
                        width: '100%'
                    }}
                >

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: "wrap",
                            width: '100%'
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: '80%',
                                marginLeft: 100,
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: 48,
                                    fontWeight: "bold",
                                    color: "#4C494B",
                                    marginTop: 80,
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["4"]}
                            </Typography>

                            <Button
                                style={{
                                    marginTop: -40,
                                    marginRight: -40
                                }}
                                onClick={() => this.props.selectSection("principal")}
                            >
                                <NavigateBefore
                                    style={{
                                        height: 30,
                                        width: 30
                                    }}
                                />
                                <Typography
                                    style={{
                                        textTransform: "none",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        marginLeft: 10,
                                        textDecoration: 'underline',
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["5"]}
                                </Typography>
                            </Button>

                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginLeft: 100
                            }}
                        >

                            <TextField
                                style={{
                                    marginTop: 40,
                                    width: 300,
                                    fontFamily: "Poppins"
                                }}
                                inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                value={this.props.nombre}
                                onChange={e => this.handleSetName(e.target.value)}
                                label={this.state.text["6"]}
                            />

                            {this.props.level === 5 &&
                            <FormControl
                                style={{
                                    marginTop: 40,
                                    width: 300
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["7"]}</InputLabel>
                                <Select
                                    style={{width: '100%', fontSize: 18, fontFamily: "Poppins"}}
                                    value={this.props.propietario}
                                    onChange={e => this.props.setPropietario(e.target.value as string)}
                                >
                                    {this.props.usuarios.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}
                                </Select>
                            </FormControl>
                            }

                            <FormControl
                                style={{
                                    marginTop: 40,
                                    width: 300
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["8"]}</InputLabel>
                                <Select
                                    value={this.props.sistema}
                                    onChange={e => this.props.setSistema(e.target.value as null | ISistemasProduccion)}
                                >
                                    {sistemasProduccion.map(el => {return <MenuItem key={el} value={el}>{el}</MenuItem>})}
                                </Select>
                            </FormControl>

                            {this.props.cultivo.length === 0 || woody_crops.includes(this.props.cultivo)  &&
                                <div
                                    style={{
                                        marginTop: 40,
                                        width: 300
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 14,
                                            color: this.state.marcoAcctivo? '#80ED99' : '#747474',
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["9"]}
                                    </Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >
                                        <TextField
                                            style={{
                                                width: 60
                                            }}
                                            type="number"
                                            value={parseFloat(this.props.marco.split('x')[0])}
                                            onChange={e => {
                                                if (isNaN(parseFloat(e.target.value))) {
                                                    this.props.setMarco('0' + 'x' + this.props.marco.split('x')[1])
                                                } else {
                                                    this.props.setMarco(e.target.value.toString() + 'x' + this.props.marco.split('x')[1])
                                                }
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'marco'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            InputProps={{ disableUnderline: true }}
                                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                        />
                                        <Typography
                                            style={{
                                                marginLeft: 15,
                                                marginRight: 55,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            X
                                        </Typography>
                                        <TextField
                                            style={{
                                                width: 60
                                            }}
                                            type="number"
                                            value={parseFloat(this.props.marco.split('x')[1])}
                                            onChange={e => {
                                                if (isNaN(parseFloat(e.target.value))) {
                                                    this.props.setMarco(this.props.marco.split('x')[0] + 'x' + '0')
                                                } else {
                                                    this.props.setMarco(this.props.marco.split('x')[0] + 'x' + e.target.value.toString())
                                                }
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'marco'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            InputProps={{ disableUnderline: true }}
                                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                        />
                                        <Typography
                                            style={{
                                                marginLeft: 20,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.state.text["10"]}
                                        </Typography>
                                    </div>
                                    <div
                                        style={{
                                            borderStyle: "solid",
                                            borderTopWidth: (this.state.hover === 'marco' || this.state.marcoAcctivo)? 2 : 1,
                                            borderLeftWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderColor: this.state.marcoAcctivo? '#80ED99' :
                                                this.state.hover === 'marco'? "black" : '#939393',
                                            height: 0,
                                            marginTop: -3
                                        }}
                                    />
                                </div>
                            }

                            {this.props.cultivo.length === 0 || woody_crops.includes(this.props.cultivo) &&
                                <div
                                    style={{
                                        marginTop: 40,
                                        width: 300
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 14,
                                            color: this.state.marcoAcctivo ? '#80ED99' : '#747474',
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["11"]}
                                    </Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                    >
                                        <TextField
                                            style={{
                                                width: 200
                                            }}
                                            type="number"
                                            value={this.props.diametro}
                                            onChange={e => {
                                                if (isNaN(parseFloat(e.target.value))) {
                                                    this.props.setDiametro(0)
                                                } else {
                                                    this.props.setDiametro(parseFloat(e.target.value))
                                                }
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'diametro'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            InputProps={{disableUnderline: true}}
                                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                        />
                                        <Typography
                                            style={{
                                                marginLeft: 20,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.state.text["10"]}
                                        </Typography>
                                    </div>
                                    <div
                                        style={{
                                            borderStyle: "solid",
                                            borderTopWidth: (this.state.hover === 'marco' || this.state.marcoAcctivo) ? 2 : 1,
                                            borderLeftWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderColor: this.state.marcoAcctivo ? '#80ED99' :
                                                this.state.hover === 'marco' ? "black" : '#939393',
                                            height: 0,
                                            marginTop: -3
                                        }}
                                    />
                                </div>
                            }

                            <TextField
                                style={{
                                    marginTop: 40,
                                    width: 300
                                }}
                                label={this.state.text["12"]}
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                    style: {fontSize: 18, fontFamily: "Poppins"}
                                }}
                                value={this.props.fecha}
                                onChange={(e) => {
                                    this.props.setFecha(e.target.value)
                                }}
                                inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            />

                            <FormControl
                                style={{
                                    marginTop: 40,
                                    width: 300
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["13"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.props.cultivo}
                                    onChange={e => {
                                        if (e.target.value === 'Ninguno') this.props.setCultivo("")
                                        else this.props.setCultivo(e.target.value as string)
                                    }}
                                >
                                    {cultivos.map(el =>{
                                        if (el === "") {
                                            return <MenuItem key={'Ninguno'} value={'Ninguno'}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["14"]}</Typography>
                                            </MenuItem>
                                        } else {
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>
                                                    {this.capitalizeFirstLetter(el).replace(/_/gi, ' ')}
                                                </Typography>
                                            </MenuItem>
                                        }
                                    })}
                                </Select>
                            </FormControl>

                            <FormControl
                                style={{
                                    marginTop: 40,
                                    width: 300
                                }}
                            >
                                <InputLabel style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["15"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.props.textura}
                                    onChange={e => {
                                        if (e.target.value === 'Ninguno') this.props.setTextura("")
                                        else this.props.setTextura(e.target.value as string)
                                    }}
                                >
                                    {texturas.map(el =>{
                                        if (el === "") {
                                            return <MenuItem key={'Ninguno'} value={'Ninguno'}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>{this.state.text["14"]}</Typography>
                                            </MenuItem>
                                        } else {
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 18, fontFamily: "Poppins"}}>
                                                    {this.capitalizeFirstLetter(el)}
                                                </Typography>
                                            </MenuItem>
                                        }
                                    })}
                                </Select>
                            </FormControl>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: 100
                            }}
                        >

                            <Typography
                                style={{
                                    marginTop: 50,
                                    fontWeight: "bold",
                                    fontSize: 20,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["16"]}
                            </Typography>

                            <Typography
                                style={{
                                    maxWidth: 300,
                                    marginTop: 20,
                                    fontSize: 16,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["73"]}
                            </Typography>

                            <FormControl
                                style={{
                                    marginTop: 20,
                                    width: 300
                                }}
                            >
                                <Autocomplete
                                    id="combo-box-demo"
                                    style={{
                                        width: "100%",
                                        fontFamily: "Poppins",
                                    }}
                                    value={{id: this.state.id_estacion, estacion: this.state.estacion}}
                                    disableClearable
                                    onInputChange={(e, v, r) => {
                                        if (r === "input") {
                                            this.setState({
                                                id_estacion: 0,
                                                estacion: v
                                            })
                                            this.getRecomendaciones(v)
                                        } else {
                                            this.setState({estacion: v})
                                        }
                                    }}
                                    options={this.state.recomendaciones}
                                    getOptionLabel={(option) => option.estacion as string}
                                    onChange={(e, v) => {
                                        setTimeout(() => this.setState({
                                                id_estacion: v.id_estacion as number,
                                                estacion: v.estacion as string
                                            }), 500)
                                    }}
                                    renderInput={(params) =>
                                        <div>
                                            <TextField
                                                multiline
                                                {...params}
                                            />
                                        </div>
                                    }
                                />
                            </FormControl>

                            <Typography
                                style={{
                                    maxWidth: 300,
                                    marginTop: 20,
                                    fontSize: 16,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["74"]}
                                <a target={'_blank'} href="https://www.tiempo.com/mundo.htm">METEORED</a>
                            </Typography>

                            <Typography
                                style={{
                                    maxWidth: 300,
                                    marginTop: 20,
                                    fontSize: 16,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["75"]}
                                <a target={'_blank'} href="https://eportal.mapa.gob.es//websiar/Inicio.aspx">SiAR</a>,
                                {this.state.text["76"]}
                                <a target={'_blank'} href="https://www.visualcrossing.com/">Visual Crossing</a>
                            </Typography>


                            <Typography
                                style={{
                                    marginTop: 60,
                                    fontWeight: "bold",
                                    fontSize: 20,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["20"]}
                            </Typography>
                            <Typography
                                style={{
                                    marginTop: 20,
                                    fontSize: 16,
                                    color: "#4C494B",
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["21"]}
                            </Typography>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: 300,
                                    height: 80
                                }}
                            >
                                {this.state.text["22"].split(',').map((letra, dia) =>
                                    <Paper
                                        elevation={this.state.hover === `dia${dia}`? 5 : 2}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 36,
                                            height: 36,
                                            borderRadius: 18,
                                            backgroundColor: this.props.dias.split(',')[dia] === '1'? '#80ED99' : '#eee',
                                            cursor: "pointer"
                                        }}
                                        onMouseEnter={() => this.setState({hover: `dia${dia}`})}
                                        onMouseLeave={() => this.setState({hover: ''})}
                                        onClick={() => {
                                            let dias = this.props.dias.split(',')
                                            if (dias[dia] === '0') {
                                                dias[dia] = '1'
                                            } else {
                                                dias[dia] = '0'
                                            }
                                            const dias_str = dias.join(',')
                                            this.props.setDias(dias_str)
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                fontSize: 18,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {letra}
                                        </Typography>
                                    </Paper>
                                )}
                            </div>




                            <Button
                                variant={"contained"}
                                color={"primary"}
                                disabled={!this.state.completo}
                                style={{
                                    marginTop: 60,
                                    marginBottom: 40,
                                    borderRadius: 20,
                                    width: 200,
                                    height: 60
                                }}
                                onClick={() => this.handleClick()}
                            >
                                {this.state.loading?
                                    <CircularProgress
                                        style={{
                                            height: 36,
                                            width: 36,
                                            color: "#b42333"
                                        }}
                                    />
                                    :
                                    <Typography
                                        style={{
                                            height: '100%',
                                            color: '#747474',
                                            fontWeight: "bold",
                                            fontSize: 32,
                                            textTransform: 'none',
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["23"]}
                                    </Typography>
                                }
                            </Button>
                        </div>
                    </div>

                </div>

                <img
                    src={Caract_IMG}
                    alt="gota img"
                />
            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    nombre: state.crearParcela.nombre,
    propietario: state.crearParcela.propietario,
    usuarios: state.principal.usuarios,
    cultivo: state.crearParcela.cultivo,
    id_estacion: state.crearParcela.id_estacion,
    ubicacion_estacion: state.crearParcela.ubicacion_estacion,
    sistema: state.crearParcela.sistema,
    marco: state.crearParcela.marco,
    diametro: state.crearParcela.diametro,
    textura: state.crearParcela.textura,
    level: state.navegacion.level,
    fecha: state.crearParcela.fecha,
    dias: state.crearParcela.dias,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setNombre: (nombre: string) => dispatch({type: "set-crear-parcela-nombre", nombre}),
    setPropietario: (propietario: string) => dispatch({type: "set-crear-parcela-propietario", propietario}),
    setCultivo: (cultivo: string) => dispatch({type:"set-crear-parcela-cultivo", cultivo}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setIdEstacion: (id_estacion: number) => dispatch({type: "set-crear-parcela-id_estacion", id_estacion}),
    setUbicacionEstacion: (ubicacion_estacion: string) => dispatch({type: "set-crear-parcela-ubicacion_estacion", ubicacion_estacion}),
    setCoordenadasEstacion: (coordenadas_estacion: IPointCoords) => dispatch({type: "set-crear-parcela-coordenadas_estacion", coordenadas_estacion}),
    setSistema: (sistema: null|ISistemasProduccion) => dispatch({type: "set-crear-parcela-sistema", sistema}),
    setMarco: (marco: string) => dispatch({type: "set-crear-parcela-marco", marco}),
    setDiametro: (diametro: number) => dispatch({type: "set-crear-parcela-diametro", diametro}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setTextura: (textura: string) => dispatch({type: "set-crear-parcela-textura", textura}),
    setCrearParcelaSection: (seccion: INewParcelaSection) => dispatch({type: "select-crear-parcela-seccion", seccion}),
    setFecha: (fecha: string) => dispatch({type: "set-crear-parcela-fecha", fecha}),
    setDias: (dias: string) => dispatch({type: "set-crear-parcela-dias", dias}),
    openEstacionesDialog: (callback: boolean) => dispatch({type: "open-estaciones", callback}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Caracterizacion);
